import { useEffect, useState } from 'react';
import { storeApi } from '../../lib/api';

export function useDeliveryQuote({ suburb, postcode, totalM2, enabled }) {
  const [quote, setQuote] = useState(null);
  const [checking, setChecking] = useState(false);
  const hasInput = Boolean((suburb || '').trim().length >= 3 || (postcode || '').trim().length === 4);

  useEffect(() => {
    if (!enabled || !hasInput) { setQuote(null); return undefined; }
    let cancelled = false;
    setChecking(true);
    const t = setTimeout(async () => {
      try {
        const { data } = await storeApi.getDeliveryQuote(suburb || undefined, postcode || undefined, totalM2 || 0);
        if (!cancelled) setQuote(data);
      } catch { if (!cancelled) setQuote(null); }
      finally { if (!cancelled) setChecking(false); }
    }, 400);
    return () => { cancelled = true; clearTimeout(t); };
  }, [suburb, postcode, totalM2, enabled, hasInput]);

  return { quote, checking, hasInput };
}
